import React, { useEffect, useState } from "react";
import Layout from "../../components/user/Layout";
import { Link, useNavigate } from "react-router-dom";
import authManager from "../../utils/authManager";
import ShowFormCards from "../../components/web/form/ShowFormCards";
import {
  DOWNLOAD_FORM_MEMBER_ROUTE,
  HOME_ROUTE,
  ID_ROUTE,
  MEMBER_PROFILE_ROUTE,
  PASSWORD_ROUTE,
  PAYMENT_WALLET_ROUTE,
} from "../../routes/web/rootRoutes";

import { GrUnorderedList } from "react-icons/gr";
import { LuIdCard, LuBell, LuKeyRound, LuLogOut } from "react-icons/lu";
import { FaUserCircle, FaAmbulance, FaFlask, FaShieldAlt, FaPiggyBank, FaFileContract, FaCreditCard, FaBalanceScale, FaGavel, FaShoppingCart, FaPills, FaFileInvoiceDollar, FaHospital, FaEnvelope, FaWallet } from "react-icons/fa";
import { RiGovernmentLine } from "react-icons/ri";
import { getFileUrl } from "../../utils/helper";

function Dashboard() {
  const navigate = useNavigate();
  const user = authManager.getUserProfile();
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    if (!user) {
      const timeout = setTimeout(() => {
        authManager.deleteAccessToken();
        authManager.deleteRole();
        authManager.deleteUserProfile();
        navigate(HOME_ROUTE);
      }, 300);
      return () => clearTimeout(timeout);
    }
  }, [user, navigate]);

  const handleCardClick = (link) => {
    if (link === "logout") {
      localStorage.clear();
      navigate("/");
    } else {
      navigate(link);
    }
  };

  const menuCards = [
  

    { title: "Ambulance service", icon: <FaAmbulance />, link: "/member/ambulance", gradient: "from-red-500 to-orange-500", bgGradient: "from-red-50 to-orange-50" },
    { title: "Blood test facility", icon: <FaFlask />, link: "/member/blood-test", gradient: "from-pink-500 to-rose-500", bgGradient: "from-pink-50 to-rose-50" },
    { title: "Insurance", icon: <FaShieldAlt />, link: "/member/insurance", gradient: "from-blue-500 to-cyan-500", bgGradient: "from-blue-50 to-cyan-50" },
    { title: "Zero balance Bank account", icon: <FaPiggyBank />, link: "/member/bank-account", gradient: "from-emerald-500 to-green-500", bgGradient: "from-emerald-50 to-green-50" },
      {
    title: "Renew Your MemberShip",
    description: "Check your payment history & dues",
    icon: <FaWallet className="text-2xl" />,
    link: PAYMENT_WALLET_ROUTE,  
    gradient: "from-amber-500 to-yellow-500",
    bgGradient: "from-amber-50 to-yellow-50",
  },
    { title: "PF & ESIC Pension Complaint", icon: <FaFileContract />, link: "/member/pension", gradient: "from-amber-500 to-yellow-500", bgGradient: "from-amber-50 to-yellow-50" },
    { title: "ID card", icon: <LuIdCard />, link: ID_ROUTE, gradient: "from-purple-500 to-indigo-500", bgGradient: "from-purple-50 to-indigo-50" },
    { title: "Payment Gateway", icon: <FaCreditCard />, link: "/member/payment", gradient: "from-teal-500 to-emerald-500", bgGradient: "from-teal-50 to-emerald-50" },
    { title: "Messages / Notification", icon: <FaEnvelope />, link: "/notifications", gradient: "from-violet-500 to-purple-500", bgGradient: "from-violet-50 to-purple-50" },
    { title: "Govt Rules", icon: <RiGovernmentLine />, link: "/member/govt-rules", gradient: "from-slate-600 to-gray-600", bgGradient: "from-slate-50 to-gray-50" },
    { title: "Your rights", icon: <FaGavel />, link: "/member/rights", gradient: "from-orange-500 to-red-500", bgGradient: "from-orange-50 to-red-50" },
    { title: "Shopping", icon: <FaShoppingCart />, link: "/member/shopping", gradient: "from-fuchsia-500 to-pink-500", bgGradient: "from-fuchsia-50 to-pink-50" },
    { title: "Medicine", icon: <FaPills />, link: "/member/medicine", gradient: "from-sky-500 to-blue-500", bgGradient: "from-sky-50 to-blue-50" },
    { title: "Loan / Credit card", icon: <FaCreditCard />, link: "/member/loan", gradient: "from-lime-500 to-green-500", bgGradient: "from-lime-50 to-green-50" },
    { title: "ITR", icon: <FaFileInvoiceDollar />, link: "/member/itr", gradient: "from-rose-500 to-red-500", bgGradient: "from-rose-50 to-red-50" },
    { title: "Forms & Applications", icon: <GrUnorderedList />, link: DOWNLOAD_FORM_MEMBER_ROUTE, gradient: "from-amber-500 to-orange-500", bgGradient: "from-amber-50 to-orange-50" },
    { title: "Change Password", icon: <LuKeyRound />, link: PASSWORD_ROUTE, gradient: "from-cyan-500 to-teal-500", bgGradient: "from-cyan-50 to-teal-50" },
    { title: "Logout", icon: <LuLogOut />, link: "logout", gradient: "from-gray-600 to-gray-800", bgGradient: "from-gray-100 to-gray-200" },
  ];

  const filteredCards = menuCards.filter(card =>
    card.title.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <Layout>
      <div className="mb-8">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-6">
          <div className="flex  justify-center items-center gap-5">
            <img
              src={getFileUrl(user.image, "members")}
              alt="profile"
              className=" w-28  rounded-full object-cover border-4 border-white"
            />

            <Link to={MEMBER_PROFILE_ROUTE} className="border bg-gradient-to-tr from-green-200 to-green-500 border-gray-400  w-64 rounded-lg shadow p-2 " >
               <div className="flex gap-4 items-center">
                 <div className="bg-gradient-to-tr rounded-full from-orange-500 to-yellow-500 w-10 h-10 flex justify-center items-center">
                    <FaUserCircle className="text-white" size={18} />
                </div>
                <h5 className="text-xl font-semibold">Personal Profile</h5>
               </div>
               <br />
               <div className="mt-auto pt-3 border-t border-gray-200/50">
                <div className="flex items-center justify-between">
                  <span className="text-xs text-gray-500 font-medium">Click to open</span>
                  <svg className="w-4 h-4 text-gray-400 transform group-hover:translate-x-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                  </svg>
                </div>
              </div>
            </Link>
          </div>



          <div className="relative w-full md:w-64">
            <input
              type="text"
              placeholder="Search services..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full px-4 py-2 pl-10 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all"
            />
            <svg className="absolute left-3 top-3 w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
          </div>




        </div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
        {filteredCards.map((card, index) => (
          <div
            key={index}
            onClick={() => handleCardClick(card.link)}
            className={`group cursor-pointer transition-all duration-300 hover:scale-[1.02] ${card.title === "Logout" ? "xl:col-span-1" : ""
              }`}
          >
            <div className={`h-full bg-gradient-to-br ${card.bgGradient} rounded-xl border border-gray-200/80 hover:border-transparent transition-all duration-300 hover:shadow-xl p-5 flex flex-col`}>
              <div className="flex items-start justify-between mb-4">
                <div className={`w-12 h-12 rounded-xl bg-gradient-to-br ${card.gradient} flex items-center justify-center shadow-md group-hover:shadow-lg transition-all duration-300`}>
                  <div className="text-white text-xl">
                    {card.icon}
                  </div>
                </div>
                <span className="text-xs font-medium px-2 py-1 rounded-full bg-white/50 text-gray-700 border border-gray-200/50">
                  {index + 1}
                </span>
              </div>

              <h3 className="text-lg font-semibold text-gray-800 mb-2 line-clamp-2 group-hover:text-transparent group-hover:bg-gradient-to-r group-hover:from-gray-800 group-hover:to-gray-600 group-hover:bg-clip-text transition-all duration-300">
                {card.title}
              </h3>

              <div className="mt-auto pt-3 border-t border-gray-200/50">
                <div className="flex items-center justify-between">
                  <span className="text-xs text-gray-500 font-medium">Click to open</span>
                  <svg className="w-4 h-4 text-gray-400 transform group-hover:translate-x-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {filteredCards.length === 0 && (
        <div className="text-center py-12">
          <div className="w-20 h-20 mx-auto mb-4 rounded-full bg-gray-100 flex items-center justify-center">
            <svg className="w-10 h-10 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <h3 className="text-xl font-semibold text-gray-700 mb-2">No services found</h3>
          <p className="text-gray-500">Try searching with different keywords</p>
          <button
            onClick={() => setSearchTerm("")}
            className="mt-4 px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors"
          >
            Clear Search
          </button>
        </div>
      )}

      <div className="mt-10">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-2xl font-bold text-gray-800">Forms & Documents</h2>
          <span className="text-sm text-blue-600 font-medium">Quick Access</span>
        </div>
        <ShowFormCards />
      </div>

      <div className="mt-8 pt-6 border-t border-gray-200">
        <p className="text-center text-sm text-gray-500">
          Need help? Contact support • Last login: Today at {new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
        </p>
      </div>
    </Layout>
  );
}

export default Dashboard;